import { Box, Button, Flex, Grid, Link, Tbody, Text, Tfoot, Thead } from '@chakra-ui/react'
import type { WaitingDiscountRequest } from 'BrokerTsLib/src/dtos'

import { useContext } from 'react'

import { Pagination, Table, TableData, TableHeader, TableRow } from '../../../components/Grid'
import { Loading } from '../../../components/Loading'
import { overLimitDiscountsContext } from './OverLimitDiscountRequestCard'
import { TableWrapper } from '../../contracts/ContractsList'
import { OverLimitDiscountRequestRow } from './OverLimitDiscountRequestRow'
import { useApp } from '@/hooks/useApp'
import { Product } from 'BrokerTsLib/src/enums'

export const OverLimitDiscountRequestList = ({
  loading,
  requests,
  withPaginator = false,
  leftFooterPart
}: {
  loading?: boolean
  requests: WaitingDiscountRequest[]
  withPaginator?: boolean
  leftFooterPart?: React.ReactNode
}) => {
  const { product } = useApp()
  const { currentPage, pageSize, totalCount, setCurrentPage, reload, ...rest } = useContext(overLimitDiscountsContext)
  loading = loading || rest.loading

  return (
    <Box sx={{ display: 'grid', gap: 4 }}>
      <TableWrapper>
        <Table cellPadding="0" cellSpacing="0">
          <Thead>
            <TableRow>
              <TableHeader>
                <p>Číslo nabídky</p>
                <p>Stav</p>
              </TableHeader>

              <TableHeader>
                <p>Datum vytvoření</p>
                <p>Datum počátku</p>
              </TableHeader>

              <TableHeader sx={{ px: 0 }}>{/* <!-- Space for initials --> */}</TableHeader>

              <TableHeader sx={{ pl: 0 }}>
                <p>Pojistník</p>
                {product == Product.VehicleInsurance && <p>Vozidlo</p>}
              </TableHeader>

              <TableHeader>
                {/* <p>Pojišťovna</p> */}
              </TableHeader>

              {/* <TableHeader>
                                <p>Požadavek</p>
                            </TableHeader> */}

              <TableHeader>
                <p>Požadavek</p>
                <p>Datum žádosti / žadatel</p>
              </TableHeader>
            </TableRow>
          </Thead>

          <Tbody>
            {!loading && ((requests?.length ?? 0) > 0) &&
                            requests.map((request) => {
                              return <OverLimitDiscountRequestRow
                                key={`${request.paramsId}_${request.offerId}`}
                                item={request} />
                            })}

            {!loading && ((requests?.length ?? 0) == 0) &&
                            <TableRow>
                              <TableData colSpan={6} py={8} textAlign={'center'}>
                                <Text>Žádné žádosti k zobrazení</Text>
                              </TableData>
                            </TableRow>
            }

            {loading &&
                            <TableRow>
                              <TableData colSpan={6} py={8}>
                                <Loading large={true} />
                              </TableData>
                            </TableRow>
            }
          </Tbody>

          {withPaginator && !loading &&
                        <Tfoot>
                          <TableRow>
                            <TableData colSpan={6}>
                              <Grid gridTemplateColumns='1fr auto 1fr'>
                                {leftFooterPart && leftFooterPart}
                                {!leftFooterPart && <Box></Box>}

                                {withPaginator && (
                                // <Flex sx={{ placeContent: 'center', flex: 1 }}>
                                  <Pagination totalCount={totalCount} currentPage={currentPage} setCurrentPage={setCurrentPage} maxButtonCount={10} pageSize={pageSize} />
                                // </Flex>
                                )}
                              </Grid>
                            </TableData>
                          </TableRow>
                        </Tfoot>}

        </Table>
      </TableWrapper >

    </Box>
  )
}
